// Agent kamera/mikrofon hazırlık kontrolü (videocall ortak kaydı §B.5, OD-3).
// Saf yardımcılar: tarayıcı API'si parametre olarak alınır, böylece testte mock'lanabilir.

export const MEDIA_ERROR_CODES = [
    'NotFoundError',
    'NotAllowedError',
    'NotReadableError',
    'OverconstrainedError',
    'NO_MEDIA_DEVICES_API',
    'UNKNOWN',
];

const MEDIA_ERROR_MESSAGES = {
    NotFoundError: 'Kamera veya mikrofon bulunamadı. Cihazın takılı olduğundan emin olun.',
    NotAllowedError: 'Kamera/mikrofon izni verilmemiş. Tarayıcı site ayarlarından izin verin.',
    NotReadableError: 'Kamera veya mikrofon başka bir uygulama tarafından kullanılıyor (Teams, Zoom vb.). Uygulamayı kapatıp tekrar deneyin.',
    OverconstrainedError: 'Kamera istenen ayarları desteklemiyor.',
    NO_MEDIA_DEVICES_API: 'Bu tarayıcı/bağlantı kamera erişimine izin vermiyor (HTTPS gerekli).',
    UNKNOWN: 'Kamera/mikrofon kontrolü başarısız oldu.',
};

export function classifyMediaError(error) {
    const name = error && error.name;
    if (name === 'NotFoundError' || name === 'DevicesNotFoundError') return 'NotFoundError';
    if (name === 'NotAllowedError' || name === 'PermissionDeniedError' || name === 'SecurityError') return 'NotAllowedError';
    if (name === 'NotReadableError' || name === 'TrackStartError' || name === 'AbortError') return 'NotReadableError';
    if (name === 'OverconstrainedError' || name === 'ConstraintNotSatisfiedError') return 'OverconstrainedError';
    return 'UNKNOWN';
}

export function mediaErrorMessage(code) {
    return MEDIA_ERROR_MESSAGES[code] || MEDIA_ERROR_MESSAGES.UNKNOWN;
}

// İzin istemi açık bırakılırsa getUserMedia hiç dönmez; kontrol bu süreden sonra 'izin yok' sayılır.
export const MEDIA_PROBE_TIMEOUT_MS = 20000;

// Gerçek bir getUserMedia denemesi: cihaz listesi izin verilmeden boş etiket döner, varlığı
// ancak gerçek açma kanıtlar. Akış hemen kapatılır — boşta kamera ışığı yanmaz.
export async function probeMedia(mediaDevices, timeoutMs = MEDIA_PROBE_TIMEOUT_MS) {
    if (!mediaDevices || typeof mediaDevices.getUserMedia !== 'function') {
        return { ready: false, errorCode: 'NO_MEDIA_DEVICES_API' };
    }
    const TIMEOUT = {};
    const pending = mediaDevices.getUserMedia({ video: true, audio: true });
    let timer;
    let stream;
    try {
        stream = await Promise.race([
            pending,
            new Promise((resolve) => { timer = setTimeout(() => resolve(TIMEOUT), timeoutMs); }),
        ]);
    } catch (error) {
        return { ready: false, errorCode: classifyMediaError(error) };
    } finally {
        clearTimeout(timer);
    }
    if (stream === TIMEOUT) {
        // Geç gelen akış kamera ışığını açık bırakmasın.
        pending.then((late) => late.getTracks().forEach(t => { try { t.stop(); } catch (_) { } }), () => { });
        return { ready: false, errorCode: 'NotAllowedError' };
    }
    const hasVideo = stream.getVideoTracks().some(t => t.readyState !== 'ended');
    const hasAudio = stream.getAudioTracks().some(t => t.readyState !== 'ended');
    stream.getTracks().forEach(t => { try { t.stop(); } catch (_) { } });
    if (!hasVideo || !hasAudio) return { ready: false, errorCode: 'NotFoundError' };
    return { ready: true, errorCode: null };
}

// İzlemede ucuz karşılaştırma için cihaz parmak izi: tür + deviceId listesi.
export async function deviceSnapshot(mediaDevices) {
    if (!mediaDevices || typeof mediaDevices.enumerateDevices !== 'function') return '';
    try {
        const devices = await mediaDevices.enumerateDevices();
        return devices
            .filter(d => d.kind === 'videoinput' || d.kind === 'audioinput')
            .map(d => `${d.kind}:${d.deviceId}`)
            .sort()
            .join('|');
    } catch (_) {
        return '';
    }
}
